var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable max-lines */
import { comparer } from 'mobx';
import { merge } from 'bernie-core';
import { Localization } from 'bernie-l10n';
import loadable from '@loadable/component';
import { CONTROLLER_EVENTS } from 'controllers/events/controller-events';
import { processClientSideDefaultRequestFields } from 'controllers/lodging/shared-controller-modules/utils';
import { isHcom, isVrbo } from 'stores/context-store-utils';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { SearchCriteriaModel, SearchCriteriaUtils, singleUseQueryParams, untrackedQueryParams } from 'stores/models';
import { getSeoData } from 'utils/controller-utils/get-seo-data';
import { getHotelInfositePageData } from 'utils/controller-utils/page-data-util';
import { isBexSplitView } from 'utils/is-bex-split-view';
import { isMobile } from 'utils/is-mobile';
import { getTrackingInfoForLogging } from 'utils/logging-utils';
import { meta } from 'utils/meta';
import { MarketingChannels } from 'constants/marketing-channels';
import { DEFAULT_HOTEL_INFOSITE_PAGE_ID, DEFAULT_HOTEL_INFOSITE_PAGE_NAME } from 'constants/pages';
const {
  withoutKeys,
  withKeys
} = merge;
export class InfositeController {
  constructor() {
    this.bundles = ['infosite'];
    // @ts-ignore
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "infosite";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: () => import( /* webpackChunkName: "infosite" */'views/lodging/infosite.tsx'),
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("views/lodging/infosite.tsx");
        }
        return eval('require.resolve')("views/lodging/infosite.tsx");
      }
    });
    this.pageId = DEFAULT_HOTEL_INFOSITE_PAGE_ID;
    // between BEX, Vrbo and Hcom - a lodging PDP should have at least 1 path segment but can have up to 4
    // * BEX PDP urls = can have 1 or 2 segment:  /<anything>.h<expediaPropertyId>.<anything> or /<language>/<anything>.h<expediaPropertyId>.<anything>
    // * Vrbo PDP urls = can have up to 4 segments: /<vrbo property id>, /<language-country>/<vrbo property id>, /<language-country>/<descriptor>/<vrbo property id>, /pdp/lo/<expedia property id>, /<language-country>/pdp/lo/<expedia property id>
    // * Hcom PDP urls = can have 2 or 3 segments: /ho<hcom property id/<location descriptor> or /<language>/ho<hcom property id>/<location descriptor>
    this.path = '/:seg1/:seg2?/:seg3?/:seg4?';
    this.routeName = 'infosite';
    this.routeData = {
      rfrrNamespace: 'HOT.HIS',
      pageName: DEFAULT_HOTEL_INFOSITE_PAGE_NAME
    };
  }
  fetchPageData(options) {
    const context = options.context;
    return Promise.resolve(Object.assign(Object.assign({}, getSeoData(context)), getHotelInfositePageData(options.query)));
  }
  // eslint-disable-next-line complexity
  fetch(options) {
    return __awaiter(this, void 0, void 0, function* () {
      var _a, _b, _c;
      if (!options || !options.stores) {
        return Promise.reject('InfositeController.fetch received invalid FetchOptions');
      }
      const {
        isServer,
        stores,
        query,
        params,
        logger,
        request
      } = options;
      const fetchStartTime = Date.now();
      const context = stores.get('context');
      const page = stores.get('page');
      const currentHotel = stores.get('currentHotel');
      const multiItem = stores.get('multiItem');
      const multiItemBusinessModel = multiItem && multiItem.cartInfo && multiItem.cartInfo.type;
      const analyticsStore = stores.get('analytics');
      const pageLayoutStore = stores.get('pageLayout');
      const experiments = stores.get('experiment');
      multiItem.isMixMatchEnabled = query.mixMatch === 'true';
      multiItem.buildContext(query);
      const {
        pageName,
        pageId,
        navigationId
      } = getHotelInfositePageData(options.query);
      // updating pageStore data as the fetchPageData (https://github.expedia.biz/Brand-Expedia/shopping-pwa/blob/master/src/common/controllers/lodging/infosite-controller.ts#L59) is not called on client side navigation currently which hinders the page data update.
      stores.get('page').pageName = pageName;
      stores.get('page').pageId = pageId;
      stores.get('page').navigationId = navigationId;
      /*
      re: propertyId - the lodging PDP url and property id landscape is complex, especially after Hcom and Vrbo migrations. The following describes the general process for resolving the property id for a PDP page request:
               * server side (handling an incoming HTTP GET PDP request):
        * BEX - the property id is parsed from the url path and set in the currentHotel store which is then passed to graphql queries to render the page - blacksmith is called in a catalyst server plugin to fetch the canonical PDP url for dated requests only (based on the presence of specific url query parameters) page requests
        
        * Hcom - the expedia property id is not present in the url path - but a blacksmith call is made in a catalyst server plugin for every dated PDP request (based on specific url query params). The call to blacksmith exchanges the incoming url path for a canonical url (for validation purposes) and an expedia property id. That id is piggy backed on the site context object fetched in a different server plugin so it can be accessed in this function (context.seoData.anvilRequests.identifiers.hotel)
                 * Vrbo - the expedia property id is not present in the url path - but a blacksmith call is made in a catalyst server plugin for every Vrbo PDP request. The call to blacksmith exchanges the incoming url path for a canonical url (for validation purposes) and an expedia property id. That id is piggy backed on the site context object fetched in a different server plugin so it can be accessed in this function (context.seoData.anvilRequests.identifiers.hotel)
               * client side (no HTTP page request is made):
        * client side navigation to this controller from SRP: currentHotel.hotelId is being set by a LodgingCard click callback whose utilizes currentHotel.setPropertyListingAsCurrentHotel(lodgingCard) to do so
        * client side navigation to this controller from another PDP page: options.params/options.params.prevParams are used to determine if a client side navigation occurred from another PDP page, such as clicking a property carousel on mweb. in which case, the property id is parsed from the url path or the expediaPropertyId url parameter is used for Vrbo SUVR/Hcom PDPs
      */
      if (isServer || this.isPDPtoPDPClientsideNavigation(params)) {
        const propertyId = this.parsePropertyIdFromRequestUrlPath(request);
        if (propertyId === null) {
          return Promise.reject('Could not parse property id from request url path.');
        }
        const isVrboOrHcom = isVrbo(context) || isHcom(context);
        // prior to the InfositeController.fetch() function executing server side
        // there is a catalyst server plugin that runs on eligible PDP requests that calls
        // blacksmith to exchange the incoming PDP url path for an expedia property id
        // this allows us to render a Vrbo/Hcom PDP without the presence the expedia property id
        // in the url path or url query params (ex. hard PDP HTTP requests with no expediaPropertyId url param)
        // this is restricted to use during server side execution since InfositeController.fetch() also runs client side
        // and context.seoData.anvilRequest.identifiers.hotel would be stale if we client side navigate to another PDP
        if (isServer && isVrboOrHcom && ((_c = (_b = (_a = context === null || context === void 0 ? void 0 : context.seoData) === null || _a === void 0 ? void 0 : _a.anvilRequest) === null || _b === void 0 ? void 0 : _b.identifiers) === null || _c === void 0 ? void 0 : _c.hotel) !== undefined) {
          currentHotel.setHotelId(Number(context.seoData.anvilRequest.identifiers.hotel));
        }
        // for PDP -> PDP client side navigation we depend on the expediaPropertyId for Vrbo SUVR/Hcom PDPs (these PDP urls dont have the expedia property id in the url path)
        else if (isVrboOrHcom && query.expediaPropertyId) {
          currentHotel.setHotelId(Number(query.expediaPropertyId));
          // else just use the property id parsed from the url: BEX Hotel-Information style and Vrbo /pdp/lo urls (MUVR) would fall to here
        } else {
          currentHotel.setHotelId(Number(propertyId));
        }
      }
      // query params cleanup
      const singleUseCriteria = withKeys(singleUseQueryParams).merge({}, options.query);
      const untrackedKeys = [...untrackedQueryParams, ...Object.keys(singleUseCriteria), 'prevQuery', 'l10n'];
      const prevQuery = withoutKeys(untrackedKeys).merge({}, query.prevQuery);
      const nextQuery = withoutKeys(untrackedKeys).merge({}, query);
      if (multiItemBusinessModel && nextQuery) {
        nextQuery.businessModelFilter = multiItemBusinessModel;
      }
      let newQuery = processClientSideDefaultRequestFields(isServer, currentHotel, nextQuery);
      if (newQuery) {
        return newQuery;
      }
      const l10n = new Localization(context.locale);
      currentHotel.searchCriteria = new SearchCriteriaModel(SearchCriteriaUtils.ensureCorrectTypes(currentHotel.searchCriteria), l10n);
      const pageLayoutTemplatePromise = pageLayoutStore.fetchPDP(String(currentHotel.hotelId), context, multiItem.isPackageShoppingPath(), experiments);
      const forceFetch = currentHotel.shouldFetch;
      if (forceFetch || !comparer.structural(prevQuery, nextQuery)) {
        // TEMP FIX: check removal after 2018-05-01 with @dboerner
        this.removeRegionIdForSEMUrls(nextQuery);
        // =====================================================
        const parsedInfositeValues = SearchCriteriaUtils.ensureCorrectTypes(SearchCriteriaUtils.parseInfositeValues(Object.assign({}, nextQuery), l10n, context.localDateFormat, isVrbo(context)));
        const incomingSearchCriteria = new SearchCriteriaModel(parsedInfositeValues, l10n);
        const criteriaChanged = this.haveCriteriaChanged(currentHotel.searchCriteria, incomingSearchCriteria, Object.keys(MarketingChannels));
        // 33486_PWA_Large_Party_Mix_Match reset cart if rooms or dates criteria changes
        const mixMatchCriteriaChanged = this.hasRoomsOrDatesChanged(currentHotel.searchCriteria, incomingSearchCriteria);
        if (multiItem && multiItem.showMixMatchExperience && mixMatchCriteriaChanged) {
          multiItem.emptyCart(context).then(() => {
            if (analyticsStore) {
              analyticsStore.trackEvent('MixMatch.EmptyCart', 'MixMatch Cart Emptied', null, null, true);
            }
          });
        }
        if (forceFetch || criteriaChanged) {
          currentHotel.setOfferData(withKeys(CurrentHotelStore.offerSearchKeys).merge({}, parsedInfositeValues));
          currentHotel.updateSearchCriteria(incomingSearchCriteria);
          currentHotel.clearPoiData();
          // keep the main searchCriteria store used in srp in sync with pdp/infosite/current hotel searchCriteria
          // this will prevent firing duplicate queries when navigating from PDP -> SRP
          this.updateSearchCriteriaStore(stores, incomingSearchCriteria);
          if (isServer) {
            return;
          }
          if (!page.seo) {
            const pageFetch = page.fetch(meta['hotel-infosite'], context.site, context.locale);
            yield pageFetch;
          }
        }
      }
      yield pageLayoutTemplatePromise;
      logger.logEvent(CONTROLLER_EVENTS.INFOSITE_CONTROLLER_FETCH, `fetchTime=${(Date.now() - fetchStartTime).toString()} ms`, `, isServer=${isServer}, ${getTrackingInfoForLogging(context)}`);
      newQuery = processClientSideDefaultRequestFields(isServer, currentHotel, nextQuery);
      if (newQuery) {
        return newQuery;
      }
    });
  }
  willDeactivate(options) {
    return __awaiter(this, void 0, void 0, function* () {
      var _a, _b;
      if (!options || !options.stores) {
        return Promise.reject('InfositeController.willDeactivate receieved an invalid StoreContainer');
      }
      const currentHotel = options.stores.get('currentHotel');
      if (currentHotel.isFailure) {
        currentHotel.shouldFetch = true;
      }
      const experiments = options.stores.get('experiment');
      const context = options.stores.get('context');
      const multiItem = options.stores.get('multiItem');
      const pageLayoutStore = options.stores.get('pageLayout');
      const useBEXQuickFiltersTemplate = isMobile(context) && ((_b = (_a = experiments === null || experiments === void 0 ? void 0 : experiments.exposures) === null || _a === void 0 ? void 0 : _a.Quick_Filters_xLOB_Lodging_mWeb_Retest) === null || _b === void 0 ? void 0 : _b.bucket) === 1;
      const isBEXGSplitViewExperimentEnabled = isBexSplitView(context, experiments);
      pageLayoutStore.setSRPTemplate(context, multiItem.isPackageShoppingPath(), useBEXQuickFiltersTemplate, isBEXGSplitViewExperimentEnabled);
    });
  }
  removeRegionIdForSEMUrls(query) {
    // TODO: SEM regionId fix (do not remove until SEM URLs have been fixed)
    if (query && /google/gi.test(query.semcid)) {
      delete query.regionId;
    }
  }
  haveCriteriaChanged(previousModel, newModel, ignoredKeys) {
    if (Boolean(newModel) && !previousModel) {
      return true;
    }
    return !comparer.structural(previousModel.toJSON(ignoredKeys), newModel.toJSON(ignoredKeys));
  }
  hasRoomsOrDatesChanged(previousModel, newModel) {
    if (newModel && !previousModel) {
      return true;
    }
    const startDateChanged = previousModel.startDate !== newModel.startDate;
    const endDateChanged = previousModel.endDate !== newModel.endDate;
    return !comparer.structural(previousModel.rooms, newModel.rooms) || startDateChanged || endDateChanged;
  }
  updateSearchCriteriaStore(stores, incomingSearchCriteria) {
    const searchCriteriaStore = stores.get('searchCriteria');
    searchCriteriaStore.hydrate(incomingSearchCriteria);
  }
  parsePropertyIdFromRequestUrlPath(request) {
    var _a, _b, _c, _d;
    const BEX_PROPERTY_ID_PATH_SEGMENT_REGEX = new RegExp('.*\\.h(?<expediaPropertyId>\\d+)\\..*', 'g');
    let result = BEX_PROPERTY_ID_PATH_SEGMENT_REGEX.exec(request.path);
    if ((_a = result === null || result === void 0 ? void 0 : result.groups) === null || _a === void 0 ? void 0 : _a.expediaPropertyId) {
      return result.groups.expediaPropertyId;
    }
    const DIGITS_REGEX = new RegExp('\\d+', 'g');
    if (request.path.includes('/pdp/lo')) {
      result = DIGITS_REGEX.exec(request.path);
      return (_b = result === null || result === void 0 ? void 0 : result[0]) !== null && _b !== void 0 ? _b : null;
    }
    const HCOM_PROPERTY_ID_PATH_SEGMENT_REGEX = new RegExp('ho(?<hcomPropertyId>\\d+).*\\/.+', 'g');
    result = HCOM_PROPERTY_ID_PATH_SEGMENT_REGEX.exec(request.path);
    if ((_c = result === null || result === void 0 ? void 0 : result.groups) === null || _c === void 0 ? void 0 : _c.hcomPropertyId) {
      return result.groups.hcomPropertyId;
    }
    const VRBO_PROPERTY_ID_PATH_SEGMENT_REGEX = new RegExp('p?(?<vrboPropertyId>\\d+)[a-z]*', 'g');
    result = VRBO_PROPERTY_ID_PATH_SEGMENT_REGEX.exec(request.path);
    if ((_d = result === null || result === void 0 ? void 0 : result.groups) === null || _d === void 0 ? void 0 : _d.vrboPropertyId) {
      return result.groups.vrboPropertyId;
    }
    return null;
  }
  // params is the options.params object passed to the InfositeController.fetch() function
  // params = { seg1: '1239873' } for /1239873 for example (Vrbo PDP)
  // params = { seg1: 'pdp', seg2: 'lo', seg3: '123456' } for /pdp/lo/123456 for example (Vrbo MUVR PDP)
  // params = { seg1: 'MGM-Grand-Las-Vegas.h123456.Hotel-Information' } for /MGM-Grand-Las-Vegas.h123456.Hotel-Information (BEX PDP)
  // params = { seg1: 'ho12345', seg2: 'kimpton-hotel-vintage-seattle-an-ihg-hotel-seattle-united-states-of-america' } for /ho130132/kimpton-hotel-vintage-seattle-an-ihg-hotel-seattle-united-states-of-america/
  // params.prevParams is an object that contains the segX slugs from the prior PDP if you client side navigate so this function checks for that
  isPDPtoPDPClientsideNavigation(params) {
    const {
        prevParams
      } = params,
      nextParams = __rest(params, ["prevParams"]);
    if (prevParams && Object.keys(prevParams).length > 0) {
      return !comparer.structural(prevParams, nextParams);
    }
    return false;
  }
}